import { useNavigate } from 'react-router-dom';
import { useAuth } from '../stores/auth';

type Props = { title: string; back?: boolean };

export default function TopBar({ title, back }: Props) {
  const nav = useNavigate();
  const insp = useAuth((s) => s.inspector);
  return (
    <header className="sticky top-0 z-30 bg-white border-b border-gray-200 px-4 py-3 flex items-center gap-3 shadow-sm">
      {back && (
        <button
          onClick={() => nav(-1)}
          className="text-gray-500 hover:text-gray-900 text-xl px-1"
          aria-label="Volver"
        >
          ←
        </button>
      )}
      <h1 className="flex-1 font-semibold text-base text-gray-900 truncate">{title}</h1>
      {insp && (
        <span className="text-xs text-gray-500 truncate max-w-[120px]">
          {insp.nombre} {insp.apellido}
        </span>
      )}
    </header>
  );
}
